'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _App = require('shared/modules/App');

var _Home = require('shared/modules/Home');

var _Page = require('shared/components/Page');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    _reactRouter.Route,
    { path: '/', component: _App.App },
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _Home.Home }),
    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _Page.Page })
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/routes.js
// module id = 1307
// module chunks = 0